import { CryptoBalance } from '@/features/Wallets/wallet.types'
import type { MessageSignerWalletAdapterProps } from '@solana/wallet-adapter-base'
import BigNumber from 'bignumber.js'
import bs58 from 'bs58'
import nacl from 'tweetnacl'

// TODO: @adil - discuss
export const availableWalletsToConnect = ['Phantom', 'Solflare', 'Ledger']

export function naclSignAndConvertToBs58({ data, secret }: {
  data: string;
  secret: Uint8Array;
}): string {
  const signedMessage = nacl.sign.detached(bs58.decode(data), secret)
  return bs58.encode(signedMessage)
}

export async function walletSignMessageAndConvertToBs58({ data, signMessage }: {
  data: string;
  signMessage: MessageSignerWalletAdapterProps['signMessage'] | undefined;
}) {
  const encodedMessage = new TextEncoder().encode(data)
  const signedMessage = await signMessage(encodedMessage)
  return bs58.encode(signedMessage)
}

export function formatTokenAmount(data: CryptoBalance, withSymbol?: boolean, raw?: boolean) {
  if (!data) return null

  const value = new BigNumber(data.amount)
    .decimalPlaces(raw ? data.decimals : 2, BigNumber.ROUND_DOWN) // TODO: displayDecimals = 4
    .toFormat()

  let finalValue = value
  const [_, decimalPart] = value.split('.')

  if (decimalPart && decimalPart.length === 1) {
    finalValue += '0'
  }

  if (withSymbol) {
    return `${finalValue} ${data.symbol}`
  }

  return finalValue
}

export function formatSimpleToken(amount: string, displayDecimals: number) {
  return new BigNumber(amount)
    .decimalPlaces(displayDecimals, BigNumber.ROUND_DOWN)
    .toString()
}

export function formatExchangeRate(numerator: string, denominator: string | undefined, displayDecimals = 4) {
  const denominatorValue = Number(denominator)

  if (!denominatorValue) return '—'

  return formatSimpleToken((Number(numerator) / denominatorValue).toString(), displayDecimals)
}

export function checkIfCorrectWalletIsConnected(pk1: string, pk2: string) {
  return pk1 === pk2
}

export function getSign(data: CryptoBalance) {
  const amount = new BigNumber(data.amount)

  if (amount.gt(0)) {
    return '+'
  }

  return ''
}
